// Shared between client (CurrencySwitcher) and server (display-currency).
// Kept in its own module so importing it doesn't drag server-only code
// (next/headers, Prisma) into the client bundle.
export const DISPLAY_CURRENCY_COOKIE = "jana_currency";
